import Region from '../../../constants/region';
import {
    AccessBayScheduling,
    AccessHaulerManagement,
    AccessPlantManagement,
    AccessProducerManagement,
    Dashboard,
    GetFluidScheduleDetails,
    GetMilkScheduleDetails,
    ListAdmins,
    ListBactoAlert,
    ListCIPWash,
    ListDrivers,
    ListDropoffs,
    ListHaulingCompanies,
    ListInvoicing,
    ListLabReports,
    ListManifests,
    ListMonthlyReports,
    ListPickups,
    ListPickupsAndLabs,
    ListProcessors,
    ListProducers,
    ListReceivers,
    ListRouteSessions,
    ListScheduleRoutes,
    ListSharedFiles,
    ListSilos,
    ListSubAdmins,
    ListSubHauling,
    ListSubProcessors,
    ListSubProducers,
    ListTrailers,
    ListTrucks,
    ListUserGroups,
    ListUserGroupsV2,
    ManageAssignees,
    ManageBankingInfo,
    ManageClosePeriod,
    ManageCustomFields,
    ManageDeferrals,
    ManageDeliveryReports,
    ManageEquity,
    ManageFuelTracking,
    ManageHaulerPayReports,
    ManageHaulingRates,
    ManageLinkedUsers,
    ManageMerchandise,
    ManageMooRules,
    ManagePaymentStatus,
    ManagePoolingDecisions,
    ManageProcessedFluidsAdjustments,
    ManageProcessedFluidCloseDay,
    ManageProcessedFluidCommodities,
    ManageProcessedFluidInvoicing,
    ManageProcessedFluidsDropoffs,
    ManageProcessedFluidsPickups,
    ManageProcessedFluidsRouteSessions,
    ViewProcessedFluidReceiving,
    ViewProcessedFluidReceivingRapidTest,
    ManageProcessorTotals,
    ManageProducerPayReports,
    ManageProducerTouchBases,
    ManageRapidTest,
    ManageSplitProducers,
    ManageVendorPayReports,
    ProducerHaulingContractsAndCharges,
    QARapidTest,
    UploadDownload,
    UploadMooRules,
    ViewAccountingReports,
    ViewContracts,
    ViewDocumentation,
    ViewDriverLocations,
    ViewHaulerPayReport,
    ViewMemberCenter,
    ViewPricing,
    ViewProcessedFluidsDriverLocations,
    ViewProducerHaulingCharges,
    ViewReceivingDropoffs,
    ViewScaleReadings,
    CanImpersonateUsers,
    ViewMilkPredictionReport,
    ViewReporting,
    ListSiloWash,
    ViewContractPerformanceReport,
    ViewSupplyOutlookReport,
} from './permissions';
import LABELS from './constants';

const region = Region.IMP;

const SubAdminGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard, // wrap
        UploadDownload,
        ViewContracts,
        AccessBayScheduling,
        ManageCustomFields,
        CanImpersonateUsers,
        ViewMilkPredictionReport,
        ViewReporting,
        ViewContractPerformanceReport,
        ViewSupplyOutlookReport,
    ],
};

const SubProcessorGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard, // wrap
        AccessPlantManagement,
        AccessBayScheduling,
        UploadDownload,
        ViewReporting,
    ],
};

const SubHaulingGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard, // wrap
        AccessHaulerManagement,
        UploadDownload,
        ViewReporting,
    ],
};

const SubAdminRawMilkTracking = {
    label: LABELS.RawMilkTracking,
    permissions: [
        GetMilkScheduleDetails(), // wrap
        ListRouteSessions(region),
        ListPickups(),
        ListDropoffs(),
        ListScheduleRoutes,
        ViewReceivingDropoffs,
        ListManifests,
        ViewDriverLocations,
        ListCIPWash,
        ManageClosePeriod,
        ManageFuelTracking,
        ManageDeliveryReports,
        ViewScaleReadings,
        ListSiloWash,
    ],
};

const SubProcessorRawMilkTracking = {
    label: LABELS.RawMilkTracking,
    permissions: [
        GetMilkScheduleDetails(), // wrap
        ListRouteSessions(region, 'View', ''),
        ListDropoffs('View', ''),
        ViewReceivingDropoffs,
        ListSiloWash,
    ],
};

const SubHaulingRawMilkTracking = {
    label: LABELS.RawMilkTracking,
    permissions: [
        GetMilkScheduleDetails('View', ''), // wrap
        ListRouteSessions(region),
        ListPickups(),
        ListDropoffs(),
        ViewDriverLocations,
        ListCIPWash,
        ManageFuelTracking,
        ViewReceivingDropoffs,
        ListSiloWash,
    ],
};

const SubAdminProcessedFluidTracking = {
    label: LABELS.ProcessedFluidTracking,
    permissions: [
        GetFluidScheduleDetails, // wrap
        ManageProcessedFluidsPickups,
        ManageProcessedFluidsDropoffs,
        ManageProcessedFluidsRouteSessions,
        ViewProcessedFluidsDriverLocations,
        ManageProcessedFluidInvoicing,
        ManageProcessedFluidCloseDay,
        ManageProcessedFluidCommodities,
        ManageProcessedFluidsAdjustments,
        ViewProcessedFluidReceiving,
        ViewProcessedFluidReceivingRapidTest,
    ],
};

const SubProcessorProcessedFluidTracking = {
    label: LABELS.ProcessedFluidTracking,
    permissions: [
        GetFluidScheduleDetails, // wrap
        ManageProcessedFluidsPickups,
        ManageProcessedFluidsDropoffs,
        ManageProcessedFluidsRouteSessions,
        ManageProcessedFluidsAdjustments,
    ],
};

const SubHaulingProcessedFluidTracking = {
    label: LABELS.ProcessedFluidTracking,
    permissions: [
        GetFluidScheduleDetails, // wrap
        ManageProcessedFluidsPickups,
        ManageProcessedFluidsDropoffs,
        ManageProcessedFluidsRouteSessions,
        ViewProcessedFluidsDriverLocations,
    ],
};

const SubAdminQuality = {
    label: LABELS.Quality,
    permissions: [
        ListLabReports(), // wrap
        ManageRapidTest,
        QARapidTest,
    ],
};

const SubProcessorQuality = {
    label: LABELS.Quality,
    permissions: [
        ManageRapidTest, // wrap
        QARapidTest,
    ],
};

const SubHaulingQuality = {
    label: LABELS.Quality,
    permissions: [
        ListLabReports(), // wrap
    ],
};

const SubAdminPayroll = {
    label: LABELS.Payroll,
    permissions: [
        ManageProducerPayReports, // wrap
        ManageHaulerPayReports,
        ViewHaulerPayReport,
        ManageVendorPayReports,
        ManagePaymentStatus,
        ManageAssignees,
        ManageDeferrals,
        ManageMerchandise(region),
        ManageSplitProducers,
        ManageMooRules,
        UploadMooRules,
        ManageHaulingRates,
        ViewPricing,
    ],
};

const SubAdminInvoicing = {
    label: LABELS.Invoicing,
    permissions: [
        ViewAccountingReports, // wrap
        ManageBankingInfo,
        ListInvoicing,
    ],
};

const SubAdminPooling = {
    label: LABELS.Pooling,
    permissions: [
        ManagePoolingDecisions, // wrap
        ManageProcessorTotals,
        ManageProducerTouchBases,
    ],
};

const SubProcessorInvoicing = {
    label: LABELS.Invoicing,
    permissions: [
        ListInvoicing, // wrap
    ],
};

const SubHaulingPayroll = {
    label: LABELS.Payroll,
    permissions: [
        ViewHaulerPayReport, // wrap
        ProducerHaulingContractsAndCharges,
    ],
};

const SubAdminMemberships = {
    label: LABELS.Memberships,
    permissions: [
        ViewMemberCenter, // wrap
        ListSharedFiles,
        ViewDocumentation,
        ManageEquity,
    ],
};

const SubProcessorMemberships = {
    label: LABELS.Memberships,
    permissions: [
        ListSharedFiles, // wrap
    ],
};

const SubHaulingMemberships = {
    label: LABELS.Memberships,
    permissions: [
        ListSharedFiles, // wrap
    ],
};

const SubAdminUsersAndAssets = {
    label: LABELS.UsersAndAssets,
    permissions: [
        ListAdmins, // wrap
        AccessProducerManagement,
        ListProducers,
        ListSubProducers,
        AccessPlantManagement,
        ListProcessors(region),
        ListSubProcessors(region),
        ListHaulingCompanies(region),
        ListSubHauling(region),
        AccessHaulerManagement,
        ListDrivers,
        ListUserGroups,
        ListUserGroupsV2,
        ListSubAdmins,
        ManageLinkedUsers,
        ListTrailers,
        ListSilos,
        ListTrucks,
    ],
};

const SubProcessorUsersAndAssets = {
    label: LABELS.UsersAndAssets,
    permissions: [
        ListReceivers, // wrap
        ListSubProcessors(region),
        ListSilos,
    ],
};

const SubHaulingUsersAndAssets = {
    label: LABELS.UsersAndAssets,
    permissions: [
        ListDrivers, // wrap
        ListSubHauling(region),
        ListTrailers,
        ListTrucks,
    ],
};

const SubProducerPermissions = {
    label: LABELS.SubProducerLabel,
    permissions: [
        Dashboard, // wrap
        ListPickups('View', ''),
        ListLabReports('View', ''),
        ListBactoAlert(region),
        ListPickupsAndLabs,
        ListSharedFiles,
        AccessProducerManagement,
        ListSubProducers,
        ListMonthlyReports(region),
        ViewMemberCenter,
        ViewProducerHaulingCharges,
        ViewReporting,
    ],
};

const SubAdmin = [
    SubAdminGeneral, // wrap
    SubAdminRawMilkTracking,
    SubAdminProcessedFluidTracking,
    SubAdminQuality,
    SubAdminPayroll,
    SubAdminInvoicing,
    SubAdminPooling,
    SubAdminMemberships,
    SubAdminUsersAndAssets,
];

const SubProcessor = [
    SubProcessorGeneral, // wrap
    SubProcessorRawMilkTracking,
    SubProcessorProcessedFluidTracking,
    SubProcessorQuality,
    SubProcessorInvoicing,
    SubProcessorMemberships,
    SubProcessorUsersAndAssets,
];

const SubHauling = [
    SubHaulingGeneral, // wrap
    SubHaulingRawMilkTracking,
    SubHaulingProcessedFluidTracking,
    SubHaulingQuality,
    SubHaulingPayroll,
    SubHaulingMemberships,
    SubHaulingUsersAndAssets,
];

const SubProducer = [SubProducerPermissions];

const REQUIRED_PERMISSIONS = {
    Admin: [
        ListSilos, // wrap
        ListUserGroups,
        ManageClosePeriod,
        ListInvoicing,
        ListManifests,
        GetMilkScheduleDetails(),
        ListTrailers,
        ManageProcessedFluidCloseDay,
    ],
};

const IMP = {
    Admin: { permissions: SubAdmin, required: REQUIRED_PERMISSIONS.Admin },
    'Sub-Admin': { permissions: SubAdmin },
    'Sub-Producer': { permissions: SubProducer },
    Accountant: { permissions: SubProducer },
    'Feed-Provider': { permissions: SubProducer },
    Nutritionist: { permissions: SubProducer },
    'Co-Owner': { permissions: SubProducer },
    Processor: { permissions: SubProcessor },
    'Sub-Processor': { permissions: SubProcessor },
    'Sub-Hauling': { permissions: SubHauling },
};

export default IMP;
